/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-08-04 14:06:55
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-08-04 14:46:53
 * @FilePath: /unifyxp-v2-store-portal/src/components/Modules/Video/index.tsx
 */
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import { get } from 'lodash';
import React from 'react';
import { OriCheckbox } from 'src/components/Antd/Checkbox/Checkbox';
import DraggableImageDisplay from 'src/components/DragRowDisplay/Image';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';
const Video = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data, onChange, error, disabled } = props;
  const videoError = get(error, 'videoError', []) || [];
  const video = get(data, 'video');
  const enableAutoPlay = get(data, 'enableAutoPlay');
  const enableMute = get(data, 'enableMute');
  const handleOnVideoChange = (data) => {
    if (onChange) {
      onChange(data);
    }
  };

  const handleOnAutoPlayChange = (e) => {
    const enableAutoPlay = e.target.checked;
    if (onChange) {
      onChange({ enableAutoPlay });
    }
  };

  const handleOnMuteChange = (e) => {
    const enableMute = e.target.checked;
    if (onChange) {
      onChange({ enableMute });
    }
  };

  return (
    <React.Fragment>
      <Section bottomBorder>
        <DraggableImageDisplay
          error={videoError.join(' ')}
          title={getI18n('general.video')}
          subtitle={`${getI18n('general.maximumfilesize')}: 500MB`}
          linkImage={video}
          description={`(${getI18n('general.allowedfiletypes')}: mov, mp4)`}
          btnText={getI18n('general.selectVideo')}
          type='Video'
          //   onDelete={() => {
          //     handleOnVideoChange({
          //       video: null,
          //     });
          //   }}
          imgOnChange={(video) => {
            handleOnVideoChange({
              video,
            });
          }}
          disabled={disabled}
        />
      </Section>
      <Section className={css.container}>
        <div className={css.checkboxContainer}>
          <OriCheckbox
            checked={enableAutoPlay}
            disabled={disabled}
            onChange={handleOnAutoPlayChange}>
            {getI18n('general.enableautoplay')}
          </OriCheckbox>
        </div>
        <OriCheckbox
          checked={enableMute}
          disabled={disabled}
          onChange={handleOnMuteChange}>
          {getI18n('general.playVideoonMute')}
        </OriCheckbox>
      </Section>
    </React.Fragment>
  );
  // const [fileList, setFileList] = React.useState(video ? [video] : []);
  // useSingleImageEffect(video, fileList, setFileList);
  // const videoUuid = get(staticData, 'videoUuid');
  // useAfterDidMountEffect(() => {
  //   if (!videoUuid) {
  //     setFileList([]);
  //   } else {
  //     const _current = last(fileList);
  //     const _dataUuid = videoUuid;
  //     const _currentUuid = get(_current, 'videoUuid');
  //     if (_dataUuid !== _currentUuid) {
  //       setFileList([image]);
  //     }
  //   }
  // }, [image]);
};
export default Video;
